import React, { useState, useEffect } from 'react';
import { Box, Chip } from '@mui/material';
import api from '../services/api';

// Import de la version frontend depuis package.json
const FRONTEND_VERSION = process.env.REACT_APP_VERSION || require('../../package.json').version;

function VersionDisplay() {
  const [backendVersion, setBackendVersion] = useState(null);

  useEffect(() => {
    // Récupérer la version du backend
    const fetchBackendVersion = async () => {
      try {
        const response = await api.get('/version');
        setBackendVersion(response.data?.data?.version);
      } catch (error) {
        console.error('Erreur lors de la récupération de la version backend:', error);
      }
    };

    fetchBackendVersion();
  }, []);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        gap: 1, 
        alignItems: 'center',
        padding: 1,
        opacity: 0.7,
        fontSize: '0.75rem'
      }}
    >
      <Chip 
        label={`Frontend v${FRONTEND_VERSION}`}
        size="small"
        variant="outlined"
        color="primary"
        sx={{ fontSize: '0.7rem', height: '20px' }}
      />
      {backendVersion && (
        <Chip 
          label={`Backend v${backendVersion}`}
          size="small"
          variant="outlined"
          color="secondary"
          sx={{ fontSize: '0.7rem', height: '20px' }}
        />
      )}
    </Box>
  );
}

export default VersionDisplay;

